import { useStaticQuery, graphql } from "gatsby"
import OgImage from "../../images/film/filmustage-og-image.jpg"
import { getSocialLinks } from "../../utils/urls"

function stripHtmlTags(html) {
  if (typeof document !== "undefined") {
    const tempDiv = document.createElement("div")
    tempDiv.innerHTML = html

    return tempDiv.textContent || tempDiv.innerText || ""
  }

  return html.replace(/<[^>]*>/g, "")
}

function cleanFields(data, fields) {
  const cleaned = {}
  fields.forEach(field => {
    if (data[field]) {
      cleaned[field] = stripHtmlTags(data[field])
    }
  })
  return cleaned
}

function MetaData({
  title: setTitle,
  description: setDescription,
  ghostData = {},
  pageType,
}) {
  const loadAllSettings = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
        }
      }
      allGhostSettings {
        edges {
          node {
            ...GhostSettingsFields
          }
        }
      }
    }
  `)

  const siteSettings = loadAllSettings.site.siteMetadata
  const ghostSettings = loadAllSettings.allGhostSettings.edges[0].node

  setTitle = setTitle ? stripHtmlTags(setTitle) : setTitle
  setDescription = setDescription
    ? stripHtmlTags(setDescription)
    : setDescription

  const ghostFields = [
    "meta_title",
    "title",
    "name",
    "og_title",
    "twitter_title",
    "meta_description",
    "excerpt",
    "bio",
    "description",
    "og_description",
    "twitter_description",
  ]
  const ghostClean = cleanFields(ghostData, ghostFields)

  const siteClean = cleanFields(siteSettings, ["title", "description"])

  const ghostSettingsClean = cleanFields(ghostSettings, [
    "twitter_title",
    "meta_title",
    "twitter_description",
    "meta_description",
  ])

  const titleFn = title => {
    return `${title} - ${
      pageType !== "blogPage" ? "Filmustage Blog" : "Filmustage"
    }`
  }

  const titleTemplate =
    ghostClean.meta_title ||
    ghostClean.title ||
    ghostClean.name ||
    (pageType !== "blogPage"
      ? ghostSettingsClean.twitter_title
      : ghostSettingsClean.meta_title) ||
    siteClean.title

  const descriptionTemplate =
    ghostClean.meta_description ||
    ghostClean.excerpt ||
    ghostClean.bio ||
    (pageType === "blogByTag" &&
      ghostClean.description &&
      ghostClean.description) ||
    (pageType === "blogByTag" &&
      !ghostClean.description &&
      `A collection of posts on ${ghostClean.name}`) ||
    (pageType !== "blogPage"
      ? ghostSettingsClean.twitter_description
      : ghostSettingsClean.meta_description) ||
    siteClean.description

  const mainTitle = titleFn(setTitle || titleTemplate)
  const ogTitle = titleFn(setTitle || ghostClean.og_title || titleTemplate)
  const twitterTitle = titleFn(
    setTitle || ghostClean.twitter_title || titleTemplate,
  )

  const mainDescription = setDescription || descriptionTemplate
  const ogDescription =
    setDescription || ghostClean.og_description || descriptionTemplate
  const twitterDescription =
    setDescription || ghostClean.twitter_description || descriptionTemplate

  const ogImage =
    ghostData.feature_image ||
    (pageType !== "blogPage"
      ? ghostSettings.twitter_image
      : ghostSettings.og_image) ||
    OgImage
  const ogImageWidth = 1200
  const ogImageHeight = 630

  const author =
    pageType === "blogByAuthor" ? ghostData : ghostData.primary_author
  const authorLinks = author
    ? [
        author.website,
        author.twitter && getSocialLinks("twitter", author),
        author.facebook && getSocialLinks("facebook", author),
      ].filter(Boolean)
    : []

  return {
    mainTitle,
    ogTitle,
    twitterTitle,
    mainDescription,
    ogDescription,
    twitterDescription,
    ogImage,
    ogImageWidth,
    ogImageHeight,
    author,
    authorLinks,
  }
}

export default MetaData
